import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { api } from '../../../services/api';
import './SentimentoPopup.css';

import img1 from './../../../../public/Images/1.png';
import img2 from './../../../../public/Images/2.png';
import img3 from './../../../../public/Images/3.png';
import img4 from './../../../../public/Images/4.png';
import img5 from './../../../../public/Images/5.png';

const sentimentos = [
    { id: 1, label: "Muito Triste", png: img1 },
    { id: 2, label: "Chateado", png: img2 },
    { id: 3, label: "Neutro", png: img3 },
    { id: 4, label: "Contente", png: img4 },
    { id: 5, label: "Muito Feliz", png: img5 },
];

export default function SentimentoPopup({ chapa, onClose }) {
    const [sentimentoSelecionado, setSentimentoSelecionado] = useState(null);
    const [observacao, setObservacao] = useState('');
    const [enviando, setEnviando] = useState(false);

    const enviarSentimento = () => {
        if (!sentimentoSelecionado) {
            Swal.fire("Atenção", "Escolha um sentimento antes de enviar.", "warning");
            return;
        }

        setEnviando(true);
        const dados = {
            chapa,
            sentimento: sentimentoSelecionado,
            texto: observacao
        };

        api.post(`/usuario/sentimento/${chapa}`, dados)
            .then(() => {
                // Atualiza a chave 'sentido' usada na Home e notifica a aplicação
                localStorage.setItem("sentido", String(sentimentoSelecionado));
                window.dispatchEvent(new Event("sentimentoAtualizado"));

                Swal.fire({
                    icon: "success",
                    title: "Obrigado!",
                    text: "Seu sentimento foi registrado com sucesso.",
                    confirmButtonColor: "#8b0000"
                }).then(() => {
                    onClose();
                });
            })
            .catch(() => {
                Swal.fire("Erro", "Não foi possível registrar seu sentimento.", "error");
            })
            .finally(() => {
                setEnviando(false);
            });
    };

    return (
        <Modal 
            show 
            centered 
            onHide={onClose}
            className="sentimento-modal-popup"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="border-0 pb-1 text-center d-block position-relative">
                <Modal.Title className="fw-bold fs-4 sentimento-modal-title">
                    Como você está se sentindo hoje?
                </Modal.Title>
                <p className="text-muted small mb-0">Sua resposta nos ajuda a acompanhar o clima da equipe.</p>
            </Modal.Header>

            <Modal.Body className="py-3">
                <div className="sentimentos-container">
                    {sentimentos.map((s) => (
                        <div 
                            key={s.id} 
                            className={`sentimento-item ${sentimentoSelecionado === s.id ? 'active' : ''}`} 
                            onClick={() => setSentimentoSelecionado(s.id)}
                            title={s.label}
                        >
                            <div className="sentimento-img-wrapper">
                                <img
                                    src={s.png}
                                    alt={s.label}
                                    className={`sentimento-img ${sentimentoSelecionado === s.id ? 'selected' : ''}`}
                                />
                            </div>
                            <span className="sentimento-label-text">{s.label}</span>
                        </div>
                    ))}
                </div>

                <Form.Group className="mt-3">
                    <Form.Label className="fw-semibold text-secondary small">
                        Observação <span className="fw-normal">(opcional)</span>
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        className="sentimento-textarea"
                        placeholder="Quer compartilhar algo mais sobre o seu dia?"
                        value={observacao}
                        onChange={e => setObservacao(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer className="border-0 pt-0 justify-content-end gap-2">
                <Button 
                    variant="light" 
                    className="btn-cancelar-sentimento"
                    disabled={enviando} 
                    onClick={() => {
                        Swal.fire("Aviso", "Você precisa registrar um sentimento para continuar.", "info");
                    }}
                >
                    Cancelar
                </Button>

                <Button 
                    className="btn-enviar-sentimento" 
                    disabled={enviando || !sentimentoSelecionado} 
                    onClick={enviarSentimento}
                >
                    {enviando ? "Enviando..." : "Enviar Sentimento"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}